<template>
    <div class="p-2 text-center ex-page-content">
        <img width="300" alt="notFound" :src="notFoundSVG"/>
        <h2 class="text-muted m-t-20 mb-2" v-html="$t('ResourceNotFound.resourceNotFound')"/>
    </div>
</template>

<script>
export default {
    name: "ResourceNotFound",
    computed: {
        notFoundSVG() {
            const section = this.$firstSectionPath;
            return require(`../../../assets/svg/taken_${section}.svg`);
        },
    },
};
</script>

<style scoped>
</style>